import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'components/atoms/modal';
import { useAppUpgradeConfirmationQuery } from 'queries/app-upgrade-confirmation';

interface Props {
  successCallback?: () => void;
}

export const AppUpgradeConfirmation: FC<Props> = ({
  successCallback = () => {
    window.location.reload();
  },
}) => {
  const { data: showUpgradeModal = false } = useAppUpgradeConfirmationQuery();

  return (
    <Modal
      title={<FormattedMessage id="app_upgrade.confirmation" />}
      visible={showUpgradeModal}
      onOk={successCallback}
      closable={false}
      cancelButtonProps={{ hidden: true }}
    />
  );
};
